const onOpenBrochure = (_url) => {
  try {
    if (window.cordova) {
      window.ktwebview.open(
        _url,
        function(response) {
          console.info('ktwebview response')
        },
        function(error) {
          console.info('ktwebview error')
        }
      )
    } else {
      window.open(_url)
    }
  } catch (e) {
    console.error('open brochure', e)
  }
}

export { onOpenBrochure }
